import { Checkbox, Table, TableBody, TableHead, TableHeader, TableRow } from 'design-system';

import type { FactsheetDetails } from '@/features/factsheet';
import ItemsTableRow from '@/features/factsheet/components/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/ItemsTab/ItemsTableRow';
import useItemsTab from '@/features/factsheet/components/FactsheetView/FactsheetWindow/FactsheetBody/Tabs/ItemsTab/useItemsTab';
import { useIsFactsheetCompact } from '@/features/factsheet/state/useIsFactsheetCompact';
import { cn } from '@/lib/utils';

const ItemsTab = ({ factsheet }: { factsheet: FactsheetDetails }) => {
  const { handleAllItemsSelection, allItemsSelected } = useItemsTab(factsheet);
  const isCompact = useIsFactsheetCompact();
  return (
    <div className='w-full'>
      <p className={cn('font-bold', isCompact && 'text-sm')}>
        Item(s) Available {factsheet.symbols?.length}
      </p>
      <Table aria-label='factsheet items table'>
        <TableHeader>
          <TableRow className='bg-gx-tile-dark [&>th]:border-b [&>th]:border-gx-text [&>th]:pb-2 [&>th]:font-bold'>
            <TableHead className='w-6 pr-2 pl-2 text-right'>
              <Checkbox
                checked={allItemsSelected}
                onCheckedChange={handleAllItemsSelection}
              />
            </TableHead>
            <TableHead>Code</TableHead>
            <TableHead>TimeRef</TableHead>
            <TableHead>PeriodType</TableHead>
            <TableHead>Period</TableHead>
            <TableHead>Alias</TableHead>
            <TableHead>TimeRef Detail</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {factsheet.symbols.map((symbol, index) => (
            <ItemsTableRow
              key={factsheet.code + index}
              code={factsheet.code}
              symbol={symbol}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
export default ItemsTab;
